export default __webpack_public_path__ + "static/media/gallery - potions_02.22d76a91.jpg";